"use client";
import React from "react";
import { useRouter } from "next/navigation";

import { useTranslations } from "next-intl";
import { FormProvider, useForm } from "react-hook-form";
import { Form, FormField, Input, Select } from "../../theme/components/Form";
import useFormValidators from "../../theme/hooks/useFormValidators";

import FormErrors from "../../theme/components/FormErrors";
import useSubscribeToNewsLetter from "../hooks/useSubscribeToNewsLetter";
import TermsField from "../../layout/components/TermsField";
const NewsletterSubscriptionForm = () => {
  const t = useTranslations();
  const router = useRouter();
  const { subscribeToNewsLetter } = useSubscribeToNewsLetter();
  const { required, validateEmail } = useFormValidators();

  const methods = useForm({
    defaultValues: {
      gender: null,
      firstName: null,
      lastName: null,
      email: null,
    },
  });
  const {
    setError,
    handleSubmit,
    register,
    formState: { errors },
  } = methods;

  const onSubmit = async (data) => {
    try {
      let success = {};
      const normalizedData = { ...data, emailAddress: data?.email };
      if (process.env.NEXT_PUBLIC_RECAPTCHA_KEY) {
        // @ts-ignore-next-line
        const reCaptcha = await grecaptcha.execute(
        // eslint-disable-line
          process.env.NEXT_PUBLIC_RECAPTCHA_KEY,
          { action: "submit" },
        );
        success = await subscribeToNewsLetter({
          reCaptcha,
          ...normalizedData,
        });
      }
      success = await subscribeToNewsLetter(normalizedData);

      if (success) router.push(t("newsletter_confirmed_success_url"));
      else setError("root.serverError", { message: t("error_generic") });
    } catch (error: any) {
      const { message, graphQLErrors } = error || {};

      if (graphQLErrors?.length) {
        return setError("root.serverError", { message: t("error_generic") });
      }
      return setError("root.serverError", {
        message: message,
      });
    }
  };
  return (
    <div className="container">
      <FormProvider {...methods}>
        <Form
          onSubmit={handleSubmit(onSubmit)}
          className="w-max-640px mx-auto row my-5 newsletter-subscription-form "
        >
          <div className="col-12">
            <Select
              name="gender"
              placeholder={t("gender")}
              options={[
                { value: "m", label: t("gender_m") },
                { value: "f", label: t("gender_f") },
              ]}
            />
          </div>
          <div className="col-6">
            <FormField
              type="text"
              label={t("firstName")}
              errorMessage={errors?.firstName?.message}
              {...register("firstName", { required })}
            />
          </div>
          <div className="col-6">
            <FormField
              type="text"
              label={t("lastName")}
              errorMessage={errors?.lastName?.message}
              {...register("lastName", { required })}
            />
          </div>
          <div className="col-12">
            <FormField
              type="email"
              {...register("email", {
                required,
                validate: validateEmail,
              })}
              errorMessage={errors?.email?.message}
              label={t("email")}
            />
          </div>
          <div className="col-12">
            <TermsField />
            <FormErrors errors={errors} />
            <Input type="submit" className="mt-3" value={t("submit")} />
          </div>
        </Form>
      </FormProvider>
    </div>
  );
};

export default NewsletterSubscriptionForm;
